var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-block px-2 text-xs font-semibold leading-snug tracking-widest text-white uppercase rounded-full",class:_vm.bgColor},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }